<div class="dlog-tab pt-2">
  @if (!dlogReady) {
    <div class="dlog-muted">DLog runtime is not available in this session.</div>
  } @else {
    <div class="dlog-toolbar">
      <ui-form
        [config]="toolbarConfig"
        [formValues]="toolbarValues"
        [containerClass]="'compact'"
        (inputChange)="onToolbarInputChange($event)"
        (buttonClick)="onToolbarButtonClick($event)"
      />
    </div>

    <div class="dlog-list">
      <app-checkbox-columns
        [checkboxes]="filteredDlogCheckboxes"
        [numColumns]="3"
        [readOnly]="false"
        [orderBy]="'alphabetical'"
        [columnWidth]="'fill'"
        (checkboxToggled)="onCheckboxColumnsToggled($event)"
      />
    </div>

    <div class="dlog-note" role="note">
      NOTE: Only loaded classes will show up here so this list may change as classes are loaded. Selections are saved in local storage.
    </div>
  }
</div>
